import React from 'react';
import KycGenericVerification from './KycGenericVerification';

export default function KycRcVerification() {
  return (
    <KycGenericVerification
      title="RC Verification"
      description="Verify vehicle registration certificate (RC) details."
      kycType="rc-verification"
      costField="rcVerificationCost"
      submitLabel="Submit RC Verification"
      inputs={[
        {
          name: 'rcNumber',
          label: 'RC Number',
          placeholder: 'MH12AB1234',
          maxLength: 30,
          validator: (value) => String(value || '').trim().length >= 5,
          errorMessage: 'RC Number is required'
        }
      ]}
      referenceFormatter={(item) => item.rcNumber || 'N/A'}
    />
  );
}
